import { useFlags } from 'launchdarkly-react-client-sdk';

export const FEATURE_FLAGS = {
    // https://app.launchdarkly.com/projects/packlink-pro/flags/new-onboarding
    'new-onboarding': false,
};

type KebabToCamelCase<S extends string> = S extends `${infer T}-${infer U}`
    ? `${T}${Capitalize<KebabToCamelCase<U>>}`
    : S;

type KebabToCamelCaseKeys<T> = {
    [K in keyof T as KebabToCamelCase<K & string>]: T[K];
};

export function useFeatureFlags() {
    const featureFlags = useFlags<KebabToCamelCaseKeys<typeof FEATURE_FLAGS>>();

    return featureFlags;
}
